import React from 'react';
import Modal from 'react-modal';
import { Icons, Button, colors, Spinner } from '@united-talent-agency/components';
import {
  CloseButtonContainer,
  ModalTitle,
  ConfirmationText,
  ConfirmButtonContainer,
} from './styles';

const modalStyles = {
  overlay: {
    background: 'rgba(0, 0, 0, 0.6)',
  },
  content: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    border: '0.5px solid rgba(0, 0, 0, 0.2)',
    background: `${colors.background} none repeat scroll 0% 0%`,
    borderRadius: 2,
    outline: 'currentcolor none medium',
    width: 454,
    overflow: 'unset',
    height: 'min-content',
    padding: '20px 0',
  },
};

/**
 * Reusable confirmation modal component.
 * @param {Object} props - Component props.
 * @param {boolean} props.isOpen - Whether the modal is open.
 * @param {Function} props.onCancel - Callback when modal is cancelled/closed.
 * @param {Function} props.onConfirm - Callback when confirm button is clicked.
 * @param {string} props.title - Modal title.
 * @param {React.ReactNode} props.children - Modal content/confirmation text.
 * @param {string} [props.confirmText="Confirm"] - Confirm button text.
 * @param {string} [props.confirmCyTag] - Cypress tag for confirm button.
 * @param {boolean} [props.loading=false] - Whether the modal is in loading state.
 * @returns {React.ReactElement} The confirmation modal.
 */
const ConfirmationModal = ({
  isOpen,
  onCancel,
  onConfirm,
  title,
  children,
  confirmText = 'Confirm',
  confirmCyTag,
  loading = false,
}) => (
  <Modal isOpen={isOpen} onRequestClose={loading ? undefined : onCancel} style={modalStyles}>
    <div>
      <CloseButtonContainer>
        <Icons.XCloseIcon
          inline
          onClick={loading ? undefined : onCancel}
          height={23}
          width={23}
          style={{
            cursor: loading ? 'not-allowed' : 'pointer',
            marginRight: -7,
            opacity: loading ? 0.5 : 1,
          }}
        />
      </CloseButtonContainer>

      <ModalTitle>{title}</ModalTitle>

      <ConfirmationText>{children}</ConfirmationText>

      <ConfirmButtonContainer>
        {loading ? (
          <Spinner size={24} />
        ) : (
          <Button data-cy={confirmCyTag} small onClick={onConfirm} text={confirmText} />
        )}
      </ConfirmButtonContainer>
    </div>
  </Modal>
);

export { BoldText } from './styles';
export default ConfirmationModal;
